// extracted by mini-css-extract-plugin
export default {"tasks":"FO-z","task":"GO-z","svg":"HO-z","text":"IO-z"};